<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Proveedores &nbsp
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-4
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Nombre',
                  v-model="query",
                )
          .column.is-offset-6.is-2
            router-link.a.button.is-black.is-rounded(to="/Requisiciones/Proveedores/Nuevo")
              | Nuevo
        .columns
          TbProveedoresPend(:proveedores="proveedoresShow" @editarProv="editarProv")
        .columns.column-blanco  
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import TbProveedoresPend from './TbProveedoresPend.vue'

  import InventarioServices from '../../services/inventario/inventario'

  export default {
    name: 'Proveedores',
    components: { Loader, NavBarInventario, TbProveedoresPend },
    data() {
      return {
        isLoading: true,
        proveedores: [],
        proveedoresShow: [],
        query: '',
      }
    },
    watch: {
      query() {
        if (this.query === '') {
          this.proveedoresShow = this.proveedores
        } else {
          const QUERY = this.query.toUpperCase()
          this.proveedoresShow = this.proveedores.filter((prov) => (`${prov.nombre} ${prov.rfc} ${prov.banco} ${prov.contacto}`).toUpperCase().includes(QUERY))
        }
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerProveedores()
      },
      backPage() {
        this.$router.back()
      },
      obtenerProveedores () {
        InventarioServices.getProveedores()
          .then((data) => {
            this.proveedores = data.map(this.convertData)
            this.proveedoresShow = this.proveedores
          })
          .catch((error) => console.log(error))
          this.isLoading = false
      },
      convertData(prov){
        return {
          ...prov,
          id: Number(prov.id),
          idBanco: Number(prov.idBanco),
          isNacional: Number(prov.isNacional)
        }
      },
      editarProv(prov) {
        this.$store.commit('editarProveedor', prov)
        this.$router.push('/Proveedores/Editar')
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ProveedoresPendientes.vue